import React from 'react'
import styled from 'styled-components'
import Plaatjie from '@ubo/plaatjie'
import { Link } from 'gatsby'
import BoxDefault from './BoxDefault'
import ParseContent from '../shared/ParseContent'

const SamenwerkingSection = styled.section`
  max-width: 75ch;
  margin-inline: auto;
  margin-bottom: 8rem;

  & h2 {
    font-size: 50px;
  }

  & p {
    text-align: justify;
  }

  .link {
    display: inline-flex;
    align-items: center;
    position: relative;
    margin-top: 1rem;

    & a {
      font-weight: bold;
    }

    &:before {
      display: block;
      content: '';
      width: 0;
      height: 0;
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      margin-right: 15px;
      border-left: 6px solid #d50032;
    }
  }

  @media (max-width: 991.98px) {
    & h2 {
      hyphens: auto;
    }
  }
`

const SamenwerkingImageWrapper = styled(BoxDefault)`
  aspect-ratio: 1/1;
  background-color: #e5e5e5;
  display: flex;

  &:after {
    border-top-width: 50px;
    border-right-width: 50px;
  }

  & img {
    object-fit: contain !important;
  }

  @media (max-width: 991.98px) {
    max-width: 250px;
    margin-inline: auto;
  }
`

function Samenwerking({ samenwerking }) {
  return (
    <SamenwerkingSection>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <ParseContent content={samenwerking.intro} />
          </div>
        </div>
        <div className="row mt-lg-5">
          <div className="col-lg-4 my-4 my-lg-0">
            <SamenwerkingImageWrapper>
              <Plaatjie image={samenwerking.image} />
            </SamenwerkingImageWrapper>
          </div>
          <div className="col-lg-8 pl-lg-5">
            <ParseContent content={samenwerking.description} />
            <div className="link">
              <Link to={samenwerking.link.url} target="_blank">
                {samenwerking.link.title}
              </Link>
            </div>
          </div>
        </div>
        <div className="row mt-lg-5">
          <div className="col-lg-4 my-4 my-lg-0">
            <SamenwerkingImageWrapper>
              <Plaatjie image={samenwerking.image2} />
            </SamenwerkingImageWrapper>
          </div>
          <div className="col-lg-8 pl-lg-5">
            <ParseContent content={samenwerking.description2} />
            <div className="link">
              <Link to={samenwerking.link2.url} target="_blank">
                {samenwerking.link2.title}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </SamenwerkingSection>
  )
}

export default Samenwerking
